import {Injectable} from '@angular/core';
import {ModalService} from '../../../services/modal/modal.service';
import {TranslateService} from '../../../utilities/translate/translate.service';
import {ProjectModule} from '../../../resources/module/project-module.interface';
import {ProjectElementStore} from '../project-element/project-element-store';
import {ProjectModuleStore} from './project-module-store';
import {ProjectSubmoduleStore} from '../project-submodule/project-submodule-store';
import {empty, EMPTY} from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectModuleService {

  public state$;

  constructor(
    private modalService: ModalService,
    private projectSubmoduleStore: ProjectSubmoduleStore,
    private projectElementStore: ProjectElementStore,
    private projectModuleStore: ProjectModuleStore,
    private translateService: TranslateService
  ) {

    this.state$ = this.projectModuleStore.state$;
  }

  /**
   * Shows a confirmation modal and then set the matching element to .active = false.
   *
   * @param id Element to delete.
   */
  delete(id: ProjectModule['_id']): void {

    const elements = this.projectElementStore.getByRelated('module', id);
    let content = this.translateService.get('module') + ' '
      + this.translateService.get('contains').toLowerCase() + ' ' + elements.length + ' ';
    if (elements.length === 1) {
      content += this.translateService.get('specification').toLowerCase();
    } else {
      content += this.translateService.getPlural('specification').toLowerCase();
    }
    content += '<br>' + this.translateService.get('areyousuredeletemodule');

    this.modalService.confirm({
      title: this.translateService.get('deletespecificationtitle'),
      content: content,
      action: this.translateService.getPlural('delete'),
      actionIcon: 'delete',
      type: 'warn'
    }).afterClosed().subscribe((click: any) => {
      if (click === this.translateService.getPlural('delete')) {
        this.projectSubmoduleStore.getByRelated('module', id).map(projectSubmodule => projectSubmodule.active = false);
        this.projectElementStore.getByRelated('module', id).map(projectElement => projectElement.active = false);
        this.projectModuleStore.delete(id);
      }
    });
  }

  /**
   * Given an element it shows the rename modal and propagates a rename action.
   *
   * @rutger Iets aangepast vanwege:
   *  - Werkt net als `this.delete()` enkel met id, haal item op om te voorkomen dat je met referentie werkt.
   *  - Als je direct `name` opgeeft, wordt de modal geskipt, handig voor bijv inline edits.
   *
   * @param id Element id.
   * @param [name] Optional name. When not given, a rename modal prompt is triggered.
   */
  rename(id: ProjectModule['_id'], name?: ProjectModule['name']): void {
    const element = this.projectModuleStore.get(id);
    if (!name) {
      this.modalService.prompt(
        this.translateService.get('rename'),
        element.name
      ).afterClosed().subscribe((response: any) => {
        if (response) {
          this.projectModuleStore.update({_id: element._id, name: response});
        }
      });
    } else {
      this.projectModuleStore.update({_id: element._id, name: name});
    }
  }

  create(module) {
    // Start the create modal prompt
    return this.modalService.prompt(this.translateService.get('addmodule'), this.translateService.get('modulename'))
      .afterClosed().pipe(switchMap(response => {
      if (response) {
        module.name = response;
        // Ask to store to handle the insert
        return this.projectModuleStore.insert(module);
      }
      return EMPTY;
    }));
  }


  refresh() {
    this.projectModuleStore.refresh();
  }
}
